export const ORGANIZER_TOPIC_MAX_LENGTH = 40;
